import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { ProviderService } from 'src/app/api/purchase/provider.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-provider',
  templateUrl: './search-provider.component.html',
  styleUrls: ['./search-provider.component.css']
})
export class SearchProviderComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedProviderEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private providerService: ProviderService) {
  }

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.providerService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.fullname} ${item.document}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearchProvider(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedProviderEvent.emit(item);
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}